<template>
  <div class="change-clock-page">
    <section class="data-section original-section">
      <h2 class="section-title">当前信息</h2>

      <div class="form-row">
        <span class="form-label">做钟类型：</span>
        <div class="field-box readonly-field">{{ currentClockTypeLabel }}</div>
      </div>
      <div class="form-row">
        <span class="form-label">技师号：</span>
        <div class="field-box readonly-field">{{ originalData.technicianCode }}</div>
      </div>
      <div class="form-row">
        <span class="form-label">项目名称：</span>
        <div class="field-box readonly-field">{{ originalData.projectName }}</div>
      </div>
      <div class="form-row">
        <span class="form-label">手牌号：</span>
        <div class="field-box readonly-field">{{ originalData.handCode }}</div>
      </div>
      <div class="form-row">
        <span class="form-label">房间号：</span>
        <div class="field-box readonly-field">{{ originalData.roomName }}</div>
      </div>
      <div class="form-row">
        <span class="form-label">做钟数量：</span>
        <div class="field-box readonly-field">{{ originalData.clockCount }}</div>
      </div>
    </section>

    <div class="section-divider"></div>

    <section class="data-section change-section">
      <h2 class="section-title">换钟信息</h2>

      <div class="form-row">
        <span class="form-label">做钟类型：</span>
        <button
          type="button"
          class="field-box select-field"
          @click="showClockTypePicker = true"
        >
          <span>{{ changeClockTypeLabel }}</span>
          <i class="arrow-icon" aria-hidden="true"></i>
        </button>
      </div>

      <div v-if="isQueueChangeClock" class="form-row">
        <span class="form-label">技师类型：</span>
        <button
          type="button"
          class="field-box select-field"
          @click="showTechnicianTypePicker = true"
        >
          <span :class="{ placeholder: !changeData.technicianTypeName }">
            {{ changeData.technicianTypeName || "请选择技师类型" }}
          </span>
          <i class="arrow-icon" aria-hidden="true"></i>
        </button>
      </div>

      <div v-else class="form-row">
        <label class="form-label" for="change-technician-code">技师号：</label>
        <input
          id="change-technician-code"
          v-model.trim="changeData.technicianCode"
          class="field-box text-input"
          type="text"
          inputmode="numeric"
          placeholder="请输入技师号"
        />
      </div>
      <div class="form-row">
        <span class="form-label">项目名称：</span>
        <button type="button" class="field-box select-field" @click="showProjectPicker = true">
          <span :class="{ placeholder: !changeData.projectName }">
            {{ changeData.projectName || "请选择项目" }}
          </span>
          <i class="arrow-icon" aria-hidden="true"></i>
        </button>
      </div>
      <div class="form-row">
        <label class="form-label" for="change-hand-code">手牌号：</label>
        <input
          id="change-hand-code"
          v-model.trim="changeData.handCode"
          class="field-box text-input"
          type="text"
          inputmode="numeric"
          placeholder="请输入手牌号"
        />
      </div>
      <div class="form-row">
        <span class="form-label">房间号：</span>
        <button type="button" class="field-box select-field" @click="showRoomPicker = true">
          <span :class="{ placeholder: !changeData.roomName }">
            {{ changeData.roomName || "请选择房间" }}
          </span>
          <i class="arrow-icon" aria-hidden="true"></i>
        </button>
      </div>
      <div class="form-row">
        <span class="form-label">做钟数量：</span>
        <div class="field-box number-stepper">
          <button
            type="button"
            :disabled="changeData.clockCount <= 1"
            @click="changeClockCount(-1)"
          >−</button>
          <input
            v-model.number="changeData.clockCount"
            type="number"
            inputmode="decimal"
            min="0.5"
            max="20"
            step="0.5"
            @blur="normalizeClockCount"
          />
          <button
            type="button"
            :disabled="changeData.clockCount >= 20"
            @click="changeClockCount(1)"
          >＋</button>
        </div>
      </div>
    </section>

    <footer class="page-footer">
      <button type="button" class="footer-button cancel-button" @click="handleCancel">
        取消
      </button>
      <button type="button" class="footer-button save-button" @click="handleSave">
        确认换钟
      </button>
    </footer>

    <project-select-popup
      v-model="showProjectPicker"
      :projects="projectOptions"
      :selected-id="changeData.projectId"
      @confirm="confirmProject"
    />
    <room-select-popup
      v-model="showRoomPicker"
      :rooms="roomOptions"
      :categories="roomCategoryOptions"
      :selected-id="changeData.roomId"
      @confirm="confirmRoom"
    />
    <technician-type-select-popup
      v-model="showClockTypePicker"
      title="选择做钟类型"
      :options="clockTypeSelectOptions"
      :selected-id="changeData.clockType"
      @confirm="confirmClockType"
    />
    <technician-type-select-popup
      v-model="showTechnicianTypePicker"
      :options="technicianTypeOptions"
      :selected-id="changeData.technicianTypeId"
      @confirm="confirmTechnicianType"
    />
  </div>
</template>

<script>
import ProjectSelectPopup from "@/components/jishi/ProjectSelectPopup";
import RoomSelectPopup from "@/components/jishi/RoomSelectPopup";
import TechnicianTypeSelectPopup from "@/components/jishi/TechnicianTypeSelectPopup";

export default {
  name: "JiShiChangeClock",
  components: {
    ProjectSelectPopup,
    RoomSelectPopup,
    TechnicianTypeSelectPopup,
  },
  data() {
    return {
      showProjectPicker: false,
      showRoomPicker: false,
      showClockTypePicker: false,
      showTechnicianTypePicker: false,
      clockTypeOptions: [
        { label: "排钟", value: "queue" },
        { label: "点钟", value: "point" },
        { label: "选钟", value: "select" },
        { label: "Call钟", value: "call" },
      ],
      technicianTypeOptions: [
        { id: "beauty", name: "美容技师" },
        { id: "massage", name: "按摩技师" },
        { id: "spa", name: "SPA技师" },
        { id: "medicine", name: "中医技师" },
      ],
      originalData: {
        clockType: "queue",
        technicianCode: "007",
        projectId: "6001",
        projectName: "精油按摩",
        handCode: "6002",
        roomId: "00005",
        roomName: "00005",
        clockCount: 1,
      },
      changeData: {
        clockType: "queue",
        technicianCode: "007",
        technicianTypeId: "",
        technicianTypeName: "",
        projectId: "6001",
        projectName: "精油按摩",
        handCode: "6002",
        roomId: "00005",
        roomName: "00005",
        clockCount: 1,
      },
      projectOptions: [
        { id: "6001", name: "精油按摩", price: 299, unit: "成人" },
        { id: "6002", name: "颈肩按摩", price: 398, unit: "1大1小" },
        { id: "6003", name: "足底按摩", price: 668, unit: "成人" },
        { id: "6004", name: "全身推拿", price: 68, unit: "成人" },
      ],
      roomCategoryOptions: ["全部", "双人间三楼", "大床房三楼", "双人棋牌室"],
      roomOptions: [
        { id: "00001", name: "00001", type: "按摩房", category: "双人间三楼", status: "preClock", detailLines: ["开 6002　按 6003"], elapsed: "00:23" },
        { id: "00002", name: "00002", type: "大床房", category: "大床房三楼", status: "occupied", detailLines: ["主 6005　同 6006"], elapsed: "02:36" },
        { id: "00003", name: "00003", type: "标准间", category: "双人间三楼", status: "occupied", detailLines: ["主 6005　同 6006"], elapsed: "00:12", timeout: true },
        { id: "00004", name: "00004", type: "棋牌室", category: "双人棋牌室", status: "idle", detailLines: [] },
        { id: "00005", name: "00005", type: "棋牌室", category: "双人棋牌室", status: "idle", detailLines: [] },
        { id: "00006", name: "00006", type: "标准间", category: "双人间三楼", status: "cleaning", detailLines: ["脏房：01:30"] },
      ],
    };
  },
  computed: {
    /**
     * 将接口中的钟型值转换为只读区域展示的中文名称。
     * 同时兼容英文状态键和接口直接返回中文的情况，未知值原样展示。
     *
     * @returns {string} 当前做钟类型的中文名称。
     */
    currentClockTypeLabel() {
      const typeMap = {
        queue: "排钟",
        point: "点钟",
        select: "选钟",
        call: "Call钟",
      };
      return typeMap[this.originalData.clockType] || this.originalData.clockType;
    },
    /**
     * 将页面钟型配置转换为 TechnicianTypeSelectPopup 统一要求的 id/name 结构。
     * 保留原 clockTypeOptions 作为业务配置，避免公共组件依赖本页面的 value/label
     * 字段命名。
     *
     * @returns {Array<Object>} 可供公共单选组件使用的钟型数组。
     */
    clockTypeSelectOptions() {
      return this.clockTypeOptions.map((item) => ({
        id: item.value,
        name: item.label,
      }));
    },
    /**
     * 获取换钟区域当前目标钟型的展示名称。
     * 未匹配到配置时返回“请选择做钟类型”，避免字段显示空白。
     *
     * @returns {string} 当前目标钟型中文名称。
     */
    changeClockTypeLabel() {
      const selectedType = this.clockTypeOptions.find(
        (item) => item.value === this.changeData.clockType
      );
      return selectedType ? selectedType.label : "请选择做钟类型";
    },
    /**
     * 判断换钟区域当前是否选择排钟。
     * 模板通过该值在“技师类型”和“技师号”两行之间切换，保存校验也复用此判断。
     *
     * @returns {boolean} true 表示换成排钟，false 表示其他钟型。
     */
    isQueueChangeClock() {
      return this.changeData.clockType === "queue";
    },
  },
  created() {
    this.initializeData();
  },
  methods: {
    /**
     * 使用路由参数初始化原始做钟数据，并将其复制为换钟区域的初始值。
     * 路由未传递某字段时保留演示值；使用对象展开创建副本，避免编辑下半区时
     * 意外修改上半区必须保持不变的原始数据。
     */
    initializeData() {
      const query = this.$route && this.$route.query ? this.$route.query : {};
      Object.keys(this.originalData).forEach((key) => {
        if (query[key] !== undefined && query[key] !== "") {
          this.originalData[key] =
            key === "clockCount" ? Number(query[key]) : query[key];
        }
      });
      this.changeData = { ...this.changeData, ...this.originalData };
    },
    /**
     * 接收公共单选组件确认的做钟类型。
     * 组件返回 { id, name }，其中 id 对应业务钟型值；切换时保留技师号和技师
     * 类型的已填值，最终保存时再根据目标钟型移除不需要的字段。
     *
     * @param {Object} clockType 已确认的做钟类型对象。
     */
    confirmClockType(clockType) {
      if (!clockType) return;
      this.changeData.clockType = clockType.id;
    },
    /**
     * 接收技师类型公共组件确认的对象，并写入换钟数据。
     *
     * @param {Object} type 已确认的技师类型，包含 id 和 name。
     */
    confirmTechnicianType(type) {
      if (!type) return;
      this.changeData.technicianTypeId = type.id;
      this.changeData.technicianTypeName = type.name;
    },
    /**
     * 接收项目公共组件返回的确认结果，只更新可编辑的换钟数据。
     *
     * @param {Object} project 已确认的项目对象。
     */
    confirmProject(project) {
      if (!project) return;
      this.changeData.projectId = project.id;
      this.changeData.projectName = project.name;
    },
    /**
     * 接收房间公共组件返回的确认结果，只更新可编辑的换钟数据。
     *
     * @param {Object} room 已确认的房间对象。
     */
    confirmRoom(room) {
      if (!room) return;
      this.changeData.roomId = room.id;
      this.changeData.roomName = room.name;
    },
    /**
     * 按 0.5 的固定步长修改换钟后的做钟数量，并限制在 0.5 到 20 之间。
     *
     * @param {number} direction 1 表示增加，-1 表示减少。
     */
    changeClockCount(direction) {
      const currentValue = Number(this.changeData.clockCount) || 1;
      const nextValue = currentValue + direction * 1;
      this.changeData.clockCount = Math.min(20, Math.max(1, nextValue));
    },
    /**
     * 修正手动输入的做钟数量。
     * 非数字恢复为 0.5，超出范围时截取到有效范围，并按 0.5 步长四舍五入。
     */
    normalizeClockCount() {
      const inputValue = Number(this.changeData.clockCount);
      const safeValue = Number.isFinite(inputValue) ? inputValue : 1;
      this.changeData.clockCount =
        Math.round(Math.min(20, Math.max(1, safeValue)) * 2) *1;
    },
    /**
     * 取消换钟编辑并返回上一页；没有可返回历史时保持当前页面。
     */
    handleCancel() {
      if (window.history.length > 1) {
        this.$router.back();
      }
    },
    /**
     * 校验换钟区域并输出原始数据和换钟数据。
     * 原始数据用于接口校验当前记录，changeData 用于提交目标值；页面本身不修改
     * 原始信息，正式接口可监听 change-clock 事件后完成保存。
     */
    handleSave() {
      this.normalizeClockCount();
      if (this.isQueueChangeClock && !this.changeData.technicianTypeId) {
        this.$toast("请选择技师类型");
        return;
      }
      if (!this.isQueueChangeClock && !this.changeData.technicianCode) {
        this.$toast("请输入技师号");
        return;
      }
      if (!this.changeData.projectId) {
        this.$toast("请选择项目");
        return;
      }
      if (!this.changeData.handCode) {
        this.$toast("请输入手牌号");
        return;
      }
      if (!this.changeData.roomId) {
        this.$toast("请选择房间");
        return;
      }
      const changedData = { ...this.changeData };
      if (this.isQueueChangeClock) {
        delete changedData.technicianCode;
      } else {
        delete changedData.technicianTypeId;
        delete changedData.technicianTypeName;
      }
      this.$emit("change-clock", {
        original: { ...this.originalData },
        changed: changedData,
      });
      this.$toast.success("保存成功");
    },
  },
};
</script>

<style scoped lang="scss">
.change-clock-page {
  min-height: 100vh;
  padding-bottom: calc(118px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: #292b2e;
  background: #fffdfa;
}

.data-section {
  padding: 26px 34px 4px 28px;
}

.section-title {
  margin: 0 0 22px 165px;
  color: #9f8551;
  font-size: 25px;
  font-weight: 500;
}

.form-row {
  display: flex;
  min-height: 60px;
  align-items: center;
  margin-bottom: 20px;
}

.form-label {
  width: 145px;
  flex: 0 0 145px;
  font-size: 27px;
  font-weight: 500;
  text-align: right;
}

.field-box {
  display: flex;
  height: 60px;
  min-width: 0;
  margin-left: 20px;
  padding: 0 24px;
  flex: 1;
  align-items: center;
  border: 1px solid #ddd8cc;
  border-radius: 14px;
  box-sizing: border-box;
  color: #a4894f;
  background: #fff;
  font-size: 25px;
}

.readonly-field {
  color: #887c68;
  background: #f8f5ef;
  user-select: none;
}

.text-input {
  width: 0;
  outline: 0;
}

.select-field {
  justify-content: space-between;
  text-align: left;

  .placeholder {
    color: #bbb3a6;
  }
}

.arrow-icon {
  width: 10px;
  height: 10px;
  border-top: 2px solid #b09a6d;
  border-right: 2px solid #b09a6d;
  transform: rotate(45deg);
}

.section-divider {
  height: 18px;
  margin: 8px 0;
  border-top: 1px solid #eee4d5;
  border-bottom: 1px solid #eee4d5;
  background: #f6f0e7;
}

.number-stepper {
  padding: 0;
  justify-content: space-between;
  overflow: hidden;

  button {
    width: 72px;
    height: 100%;
    border: 0;
    color: #a4894f;
    background: #faf6ef;
    font-size: 31px;

    &:disabled {
      color: #d6cec0;
    }
  }

  input {
    width: 100px;
    height: 100%;
    border: 0;
    color: #a4894f;
    background: transparent;
    font-size: 26px;
    text-align: center;
    outline: 0;
    appearance: textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      appearance: none;
    }
  }
}

.page-footer {
  position: fixed;
  z-index: 10;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  height: calc(106px + env(safe-area-inset-bottom));
  padding: 12px 30px env(safe-area-inset-bottom);
  align-items: flex-start;
  justify-content: space-between;
  border-top: 1px solid #eee5d7;
  box-sizing: border-box;
  background: #fffdfa;
}

.footer-button {
  width: 320px;
  height: 78px;
  border-radius: 40px;
  font-size: 31px;
  font-weight: 500;
}

.cancel-button {
  border: 1px solid #ded7ca;
  color: #b49a64;
  background: #faf7f1;
}

.save-button {
  border: 0;
  color: #fff;
  background: linear-gradient(90deg, #d0ad68, #f0c875);
}
</style>
